import React from 'react'
import { Link, useLocation } from 'react-router-dom'

function Header() {
    const location = useLocation()

    const isActive = (path) =>
        location.pathname === path ? 'nav-link active' : 'nav-link'

    return (
        <header className="main-header">
            <div className="header-sticky">
                <nav className="navbar navbar-expand-lg">
                    <div className="container">
                        <Link className="navbar-brand" to="/">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/fidelanchor-logo-final.png`}
                                alt="Logo"
                            />
                        </Link>
                        <div className="collapse navbar-collapse main-menu">
                            <div className="nav-menu-wrapper">
                                <ul className="navbar-nav mr-auto" id="menu">
                                    <li className="nav-item">
                                        <Link className={isActive('/')} to="/">
                                            Home
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            className={isActive('/services')}
                                            to="/services"
                                        >
                                            Services
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            className={isActive('/clients')}
                                            to="/clients"
                                        >
                                            Clients
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            className={isActive('/about')}
                                            to="/about"
                                        >
                                            About Us
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            className={isActive('/faqs')}
                                            to="/faqs"
                                        >
                                            FAQs
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            className={isActive('/contact')}
                                            to="/contact"
                                        >
                                            Contact Us
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-md-4 col-6">
                                <div className="header-btn d-inline-flex">
                                    <a
                                        href="https://cooperative.fidelanchor.com"
                                        className="btn-default btn-highlighted"
                                    >
                                        Join Coop
                                    </a>
                                </div>
                            </div>
                            <div className="navbar-toggle"></div>
                        </div>
                    </div>
                </nav>
                <div className="responsive-menu"></div>
            </div>
        </header>
    )
}

export default Header
